// extracted by mini-css-extract-plugin
module.exports = {"share":"share-with_share__y71wr flex justify-center","sharelist":"share-with_sharelist__N9i4M","shareheader":"share-with_shareheader__mxGsW"};